module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[30]29.75b4083.woff2";